module.exports = __webpack_public_path__ + "img/icon-schedule-blue.2300829f.svg";